export default (svg: string) => {
  const encodedSvg = encodeURIComponent(svg);
  const dataUri = `data:image/svg+xml, ${encodedSvg}`;

  return dataUri;
};
